import eoriLogo from '../images/EORI-COMPUTER-svg.svg';
import './footer.css';
import HelpWidget from './HelpWidget';

const Footer = () => {
  return (
    <footer className="footer footer-text">
      <a href="https://www.eori.uk/" target="_blank" rel="noreferrer" className="navbar-brand">
        <img src={eoriLogo} width="52" alt="EORI Logo" />
        <span className="logo-text mt-1 footer-block-text">EORI (UK) LIMITED</span>
      </a>
      <span />
      <a target="_blank" href="/assets/terms-and-conditions.pdf" className="footer-block-text">
        Terms and Conditions
      </a>
      <span />
      <span className="footer-block-text">CABIE Release: {process.env.REACT_APP_VERSION}</span>
      <span />
      <a target="_blank" rel="noreferrer" href="https://www.eori.uk/privacy-policy" className="footer-block-text">
        Privacy Notice
      </a>
      <span />
      <HelpWidget />
    </footer>
  );
};

export default Footer;
